import * as swcHelpers from '@swc/helpers';
import { getLocalizedString } from '@grandvisionhq/utils';
import { toBaseLineItem } from './base-line-item.js';
import { getLineItemImageUrl } from '../../../utils/get-line-item-image-url.js';
import { getProductTitle } from './utils/get-product-title.js';
import { getAttribute } from '../../../utils/get-line-item-attribute.js';
import { getProductA11yLabel } from './utils/get-product-a11y-label.js';

const toRegularCartLineItem = (cartLineItem, intl, settings)=>{
    const imageUrl = getLineItemImageUrl(cartLineItem.legacyProduct.masterData.current.variant, settings.staticsUrl, settings.isBynderImagesEnabled);
    const base = toBaseLineItem(cartLineItem, settings, intl);
    const variant = cartLineItem.legacyProduct.masterData.current.variant;
    let title = getProductTitle(cartLineItem.legacyProduct, intl);
    let subtitle = '';
    switch(cartLineItem.legacyProduct.productType.toLowerCase()){
        case 'solutions':
            title = getLocalizedString(cartLineItem.legacyProduct.masterData.current.name, intl.locale);
            subtitle = `${getAttribute(variant, 'solutionType')}, ${getAttribute(variant, 'volume')}${getAttribute(variant, 'volumeUnit') || 'ml'}`;
            break;
        case 'frames':
            subtitle = `${getAttribute(variant, 'brandModel')}, ${intl.getLabel('products.frames.frameOnly.description')}`;
            break;
        case 'sunglasses':
        case 'accessories':
            subtitle = getAttribute(variant, 'brandModel');
            break;
    }
    return swcHelpers.objectSpread({}, base, {
        imageUrl,
        subtitle,
        title,
        altText: getProductA11yLabel(cartLineItem, intl),
        sku: cartLineItem.sku,
        type: 'REGULAR'
    });
};

export { toRegularCartLineItem };
//# sourceMappingURL=regular-line-item.js.map
